import { useMemo, useState } from "react";

export interface SelectRow { [keyExtractor: string]: string; };

export interface UseTableSelect {
  keyExtractor: string;
  items: { [key: string]: boolean; };
  setItems: React.Dispatch<React.SetStateAction<{ [key: string]: boolean; }>>;
  selectedItems: string[];
  selectAll: (checked: boolean) => void;
  selectItem: (row: any, checked: boolean) => void;
  clearSelectedItems: () => void;
  isAllSelected: boolean;
}

const useTableSelect: (keyExtractor: string) => UseTableSelect = (keyExtractor: string) => {
  const [items, setItems] = useState<{ [key: string]: boolean; }>({});

  const selectedItems = Object.entries(items).filter(([, checked]) => checked).map(([key]) => key);

  const isAllSelected = useMemo(() => {
    return selectedItems.length === Object.keys(items).length && Object.keys(items).length > 0
  }, [Object.keys(items).length, selectedItems.length]);

  const selectAll = (checked: boolean) => {
    setItems((prev) => Object.fromEntries(Object.entries(prev).map(([key]) => [key, checked])));
  };

  const selectItem = (row: any, checked: boolean) => {
    setItems((prev) => ({ ...prev, [(row as SelectRow)[keyExtractor]]: checked }));
  };

  const clearSelectedItems = () => {
    setItems((prev) => Object.fromEntries(Object.entries(prev).map(([key]) => [key, false])));
  }

  return {
    keyExtractor,
    items,
    setItems,
    selectedItems,
    selectAll,
    selectItem,
    clearSelectedItems,
    isAllSelected,
  };
};

export default useTableSelect;
